import React, {Fragment, useState, useRef, useImperativeHandle} from 'react';

import FieldsetContainer from "root/Base/FieldsetContainer";
import BootstrapRow from "ui/BootstrapRow";
import BootstrapCol from "ui/BootstrapCol";
import DropdownEducationStatus from "ui/DropdownEducationStatus";
import UserInputCheckbox from "ui/ReactUserInputCheckbox";

const EducationStatusForm = React.forwardRef(({readOnly, displayErrors, child}, ref) =>
{
   const initialChildEducationId = child.education_status_id === null ? null :+(child.education_status_id) ;

   const checkboxCareLeaver = useRef(null);
   const [isCareLeaver, setCareLeaver] = useState(+(child.care_leaver_flag) === 1)

   const checkboxPEPOptOut = useRef(null);
   const [hasOptedOut, setHasOptedOut] = useState(+(child.pep_opt_out_flag) === 1)

   const [ educationStatusId, setEducationStatusId ] = useState ( initialChildEducationId ) ;

   useImperativeHandle(ref, () => ({
      getFormData()
      {
         return getFormDataLocal();
      },
      formIsValid()
      {
         return formIsValidLocal();
      },
   }))

   const getFormDataLocal = () =>
   {
      return (
         {
            education_status_id: educationStatusId,
            care_leaver_flag: isCareLeaver ? 1 : 0,
            pep_opt_out_flag: hasOptedOut ? 1 : 0,
         }
      )
   }

   const formIsValidLocal = () =>
   {
      let valid = true;

      if (educationStatusId === null)
      {
         valid = false;
      }

      return valid;
   }

   const onChangeStatutoryReferral = (newValue) =>
   {
      setEducationStatusId(newValue.value);
   }

   const educationStatusSection = () =>
   {
      return (
         <Fragment>
            <div key='edid' className='col-md-12'>
               <DropdownEducationStatus validation={{required: true}}
                                                 onChange={onChangeStatutoryReferral}
                                                 value={ initialChildEducationId }
                                                 readOnly={readOnly}
                                                 labelClassName='col-form-label'
                                                 label='Select the Education Status' defaultClassName=''/>
               {displayErrors === true && educationStatusId === null &&
                  <div className='input-error-visible'>You must select an education status for this child</div>}
            </div>
         </Fragment>
      )
   }

   const onChangeCareLeaver = (v) =>
   {
      setCareLeaver(v);
   }

   const onChangeOptOut = (v) =>
   {
      setHasOptedOut(v);
   }
   const careLeaverSection = () =>
   {
      return (
          <Fragment>
             <BootstrapCol key='ckleave' width={6}>
                <UserInputCheckbox
                    readOnly={readOnly}
                    key='CheckboxCareLeaver'
                    ref={checkboxCareLeaver}
                    defaultValue={isCareLeaver}
                    onChange={onChangeCareLeaver}
                    label='Care Leaver?'/>
             </BootstrapCol>
             <BootstrapCol key='ckleave2' width={6}>
                <UserInputCheckbox
                    readOnly={readOnly}
                    key='CheckboxOptOut'
                    ref={checkboxPEPOptOut}
                    defaultValue={hasOptedOut}
                    onChange={onChangeOptOut}
                    label='Young Person has Opted Out Of PEP?'/>
             </BootstrapCol>
          </Fragment>
      )
   }

   return (
      <BootstrapRow>
         <BootstrapCol width={12}>
            <FieldsetContainer title='Education Status'>
               <BootstrapRow>
                  {educationStatusSection()}
               </BootstrapRow>
               <BootstrapRow>
                  {careLeaverSection()}
               </BootstrapRow>
            </FieldsetContainer>
         </BootstrapCol>
      </BootstrapRow>
   )
})

export default EducationStatusForm;
